import * as React from 'react';
export const IcGames = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 8h-3a3 3 0 00-3-3 1 1 0 01-1-1 1 1 0 00-2 0 3 3 0 003 3 1 1 0 011 1H8a6 6 0 100 12 5.93 5.93 0 003.28-1h1.44A5.93 5.93 0 0016 20a6 6 0 100-12zm-7 7H8v1a1 1 0 11-2 0v-1H5a1 1 0 010-2h1v-1a1 1 0 112 0v1h1a1 1 0 010 2zm7.07-3.38c.056-.12.13-.232.22-.33a1 1 0 011.09-.21c.061.02.119.05.17.09.057.035.11.075.16.12a1 1 0 01.21.33 1 1 0 01-.21 1.09 1.15 1.15 0 01-.33.21.94.94 0 01-.76 0 1 1 0 01-.33-.21 1 1 0 01-.22-1.09zm-.36 3.09a1.15 1.15 0 01-.33.21.94.94 0 01-.76 0 1 1 0 01-.33-.21A1 1 0 0114 14a1 1 0 112 0 1 1 0 01-.29.71zm2.21 1.67a1.15 1.15 0 01-.21.33.999.999 0 01-1.09.21 1 1 0 01-.33-.21 1 1 0 01-.22-1.09c.056-.12.13-.232.22-.33a.999.999 0 011.09-.21c.121.05.233.122.33.21a1 1 0 01.21.33.94.94 0 010 .76zm1.78-1.67a1 1 0 01-1.41-1.42l.15-.12a.762.762 0 01.18-.09.639.639 0 01.18-.08 1 1 0 011.125.604c.052.126.077.26.075.396a1 1 0 01-.3.71z'
      fill='currentColor'
    />
  </svg>
);
